import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MenuIcon, XIcon, PhoneIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Home',
    to: '/'
  }, {
    name: 'About',
    to: '/about'
  }, {
    name: 'Services',
    to: '/services'
  }, {
    name: 'How It Works',
    to: '/how-it-works'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/90 backdrop-blur-md shadow-sm py-2' : 'bg-white py-3'}`} data-id="element-190">
      <div className="max-w-7xl mx-auto px-4 flex items-center justify-between" data-id="element-191">
        {/* Logo */}
        <Link to="/" className="flex items-center group" data-id="element-192">
          <img src="https://cdn.magicpatterns.com/uploads/bw7AM2ZxN5rndR2BD9QGFb/Gemini_Generated_Image_e872g4e872g4e872-removebg-preview.png" alt="Ambient Solutions LLC — A Tailored Path to Optimal Health" className="h-20 w-auto drop-shadow-sm brightness-[1.05]" data-id="element-193" />
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8" data-id="element-194">
          {navLinks.map(link => {
          const isActive = location.pathname === link.to;
          return <Link key={link.name} to={link.to} className={`text-sm font-medium transition-colors relative pb-1 ${isActive ? 'text-primary' : 'text-neutral-medium hover:text-primary'}`} data-id="element-195">
                {link.name}
                {isActive && <motion.div layoutId="nav-underline" className="absolute bottom-0 left-0 right-0 h-0.5 bg-accent rounded-full" transition={{
              type: 'spring',
              stiffness: 400,
              damping: 30
            }} data-id="element-196" />}
              </Link>;
        })}
        </nav>

        {/* Desktop CTA */}
        <div className="hidden md:flex items-center gap-6" data-id="element-197">
          <a href="tel:+18666528987" className="flex items-center gap-2 text-neutral-dark hover:text-primary transition-colors font-medium text-sm" data-id="element-198">
            <PhoneIcon className="w-4 h-4" data-id="element-199" />
            <span data-id="element-200">(866) 652-8987</span>
          </a>
          <Link to="/contact" className="bg-primary hover:bg-primary-dark text-white px-5 py-2.5 rounded-lg font-semibold text-sm transition-colors shadow-sm hover:shadow-md" data-id="element-201">
            Get Started
          </Link>
        </div>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden p-2 text-neutral-dark" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-202">
          {isMobileMenuOpen ? <XIcon className="w-6 h-6" data-id="element-203" /> : <MenuIcon className="w-6 h-6" data-id="element-204" />}
        </button>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-205">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-white border-t border-gray-100 overflow-hidden" data-id="element-206">
            <div className="px-4 py-6 flex flex-col gap-4" data-id="element-207">
              {navLinks.map(link => {
            const isActive = location.pathname === link.to;
            return <Link key={link.name} to={link.to} onClick={() => setIsMobileMenuOpen(false)} className={`text-lg font-medium py-2 border-b border-gray-50 ${isActive ? 'text-primary border-b-2 border-accent' : 'text-neutral-dark'}`} data-id="element-208">
                    {link.name}
                  </Link>;
          })}
              <div className="pt-4 flex flex-col gap-4" data-id="element-209">
                <a href="tel:+18666528987" className="flex items-center justify-center gap-2 text-primary font-medium py-3 bg-primary/5 rounded-lg" data-id="element-210">
                  <PhoneIcon className="w-5 h-5" data-id="element-211" />
                  <span data-id="element-212">(866) 652-8987</span>
                </a>
                <Link to="/contact" onClick={() => setIsMobileMenuOpen(false)} className="bg-primary text-white text-center px-6 py-3 rounded-lg font-semibold" data-id="element-213">
                  Get Started Today
                </Link>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}